import { render } from "./DocumentStatusesMail.vue?vue&type=template&id=0434aa8f&scoped=true"
import script from "./DocumentStatusesMail.vue?vue&type=script&lang=js"
export * from "./DocumentStatusesMail.vue?vue&type=script&lang=js"

import "./DocumentStatusesMail.vue?vue&type=style&index=0&id=0434aa8f&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0434aa8f"]])

export default __exports__